import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHandlerFn,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export function tokenInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('token');
    const idToken = localStorage.getItem('id_token');
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    const isRouteeRequest: boolean =
        req.url.toLowerCase().search('.routee.net') !== -1;
    const isWasabiRequest: boolean =
        req.url.toLowerCase().search('.wasabisys.com') !== -1;

    // if (
    //   req.url.toLowerCase().search('/authorized') !== -1 ||
    //   req.url.toLowerCase().search('services.eof.gr') !== -1 ||
    //   req.url.toLowerCase().search('/AddClientToGroup'.toLowerCase()) !== -1 ||
    //   req.url.toLowerCase().search('/LogOffUser'.toLowerCase()) !== -1 ||
    //   req.url.toLowerCase().search('/RemoveClientFromGroup'.toLowerCase()) !==
    //     -1 ||
    //   req.url.toLowerCase().search('/wasabisys.com') !== -1
    // ) {}
    const authenticationURIs = ['/graphql/Authorized/'.toLocaleLowerCase()];
    const countOfRequireAuthenticationURIs = authenticationURIs
        .map((uri) => req.url.toLocaleLowerCase().indexOf(uri) !== -1)
        .filter((result) => result == true).length;

    // If the request requires a Bearer Token
    if (countOfRequireAuthenticationURIs > 0) {
        if (
            req.url.toLocaleLowerCase().search('/authorizedpostuploadfile') > 1
        ) {
            req = req.clone({
                // setParams: {
                //   observe: 'response'
                // },
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`,
                    //'Content-Type': 'multipart/form-data;',
                    enctype: 'multipart/form-data;',
                    'Access-Control-Allow-Origin': '*',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'access-control-expose-headers': 'Www-Authenticate',
                    'X-Platform': environment.XPlatform,
                    'X-PlatformOwner': environment.XPlatformOwner,
                    'X-PlatformAuthor': environment.XPlatformAuthor
                }
            });
        } else {
            req = req.clone({
                // setParams: {
                //   observe: 'response'
                // },
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json;',
                    'Access-Control-Allow-Origin': '*',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'access-control-expose-headers': 'Www-Authenticate',
                    'X-Platform': environment.XPlatform,
                    'X-PlatformOwner': environment.XPlatformOwner,
                    'X-PlatformAuthor': environment.XPlatformAuthor
                }
            });
        }
    }

    // if (isRouteeRequest === false && isWasabiRequest === false) {
    //   req = req.clone({
    //     setHeaders: {
    //       'X-Production': environment.production.toString(),
    //       'X-Platform': 'CashRegisterPro',
    //       'Access-Control-Allow-Origin': '*',
    //       'Cache-Control': 'no-cache, no-store, must-revalidate',
    //     },
    //   });
    // } else {
    // }

    return next(req);
}

// @Injectable()
// export class TokenInterceptor implements HttpInterceptor {
//   constructor(private authorizationService: AuthorizationService) {}

//   intercept(request: HttpRequest<unknown>, next: HttpHandlerFn) {
//     const token = localStorage.getItem('token');
//     const idToken = localStorage.getItem('id_token');
//     const accessToken = localStorage.getItem('access_token');
//     const refreshToken = localStorage.getItem('refresh_token');

//     const isRouteeRequest: boolean =
//       request.url.toLowerCase().search('.routee.net') !== -1;
//     const isWasabiRequest: boolean =
//       request.url.toLowerCase().search('.wasabisys.com') !== -1;

//     /* https://connect.routee.net/2step */
//     if (isRouteeRequest === false && isWasabiRequest === false) {
//       request = request.clone({
//         setHeaders: {
//           'X-Production': environment.production.toString(),
//           'X-Platform': 'CashRegisterPro',
//           'Access-Control-Allow-Origin': '*',
//           'Cache-Control': 'no-cache, no-store, must-revalidate',
//         },
//       });

//       return next(request);
//     }

//     // If the request requires a Bearer Token
//     if (
//       request.url.toLowerCase().search('/authorized') !== -1 ||
//       request.url.toLowerCase().search('services.eof.gr') !== -1 ||
//       request.url.toLowerCase().search('/AddClientToGroup'.toLowerCase()) !==
//         -1 ||
//       request.url.toLowerCase().search('/LogOffUser'.toLowerCase()) !== -1 ||
//       request.url
//         .toLowerCase()
//         .search('/RemoveClientFromGroup'.toLowerCase()) !== -1 ||
//       request.url.toLowerCase().search('/wasabisys.com') !== -1
//     ) {
//       if (request.url.toLowerCase().search('/authorizedpostuploadfile') > 1) {
//         request = request.clone({
//           // setParams: {
//           //   observe: 'response'
//           // },
//           setHeaders: {
//             Authorization: `Bearer ${accessToken}`,
//             //'Content-Type': 'multipart/form-data;',
//             enctype: 'multipart/form-data;',
//             'Access-Control-Allow-Origin': '*',
//             'Cache-Control': 'no-cache, no-store, must-revalidate',
//             'access-control-expose-headers': 'Www-Authenticate',
//           },
//         });
//       } else {
//         request = request.clone({
//           // setParams: {
//           //   observe: 'response'
//           // },
//           setHeaders: {
//             Authorization: `Bearer ${accessToken}`,
//             'Content-Type': 'application/json;',
//             'Access-Control-Allow-Origin': '*',
//             'Cache-Control': 'no-cache, no-store, must-revalidate',
//             'access-control-expose-headers': 'Www-Authenticate',
//           },
//         });
//       }

//       return next.handle(request).pipe();
//     }

//     return next.handle(request);

//     // if (this.authorizationService.getJwtToken()) {
//     //   request = this.addToken(request, this.authService.getJwtToken());
//     // }

//     // return next.handle(request).pipe(
//     //   catchError((error) => {
//     //     if (error instanceof HttpErrorResponse && error.status === 401) {
//     //       return this.handle401Error(request, next);
//     //     } else {
//     //       return throwError(() => error);
//     //     }
//     //   })
//     // );
//   }

//   private addToken(request: HttpRequest<any>, token: string) {
//     return request.clone({
//       setHeaders: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//   }
// }
